import { api } from '@/lib/api'
import type { AuthUser, Role } from '@/features/auth/types'

/**
 * Public invite endpoints (no auth cookie). The token from the email is the
 * credential. Accepting sets the password and logs the user in (cookies are
 * set by the backend response).
 */

export interface InvitePreview {
  email: string
  name: string
  org_name: string
  role: Role
}

export function previewInvite(token: string): Promise<InvitePreview> {
  return api.get<InvitePreview>('/invite', { params: { token } })
}

export function acceptInvite(token: string, password: string): Promise<AuthUser> {
  return api.post<AuthUser>('/invite/accept', { token, password })
}
